module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PKOBP SKO Quiz","short_name":"SKO","start_url":"/","background_color":"#004c9a","theme_color":"#004c9a","display":"minimal-ui","icon":"src/images/pko-icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"16440023931f418c1cfc5844333ad6c6"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
